
// The width and height in pixels of Mel's original demo images. Our canvas-filling functions have sizes defined as
// number-of-pixels-in-demo, so we need to expose these values as constants here to adjust as needed.
export const DEMO_WIDTH = 270;
export const DEMO_HEIGHT = 400;
// When drawing a box around a line of text, make the height of the box (text-height * this-number).
export const TEXT_HEIGHT_MULTIPLIER = 1.2;

// Not clear if this needs to be scaled to the canvas-size somehow.
export const DEFAULT_LINE_HEIGHT = 15;
